import { cache } from 'swr';

function getStorage(mode) {
  switch (mode) {
    case 'local':
      return localStorage;

    case 'session':
      return sessionStorage;

    default:
      {
        throw new Error("Invalid mode " + mode + ", it must be either local or session.");
      }
  }
} // the value of SWR could be either undefined or an object
// if you had other values you will need to check them here
// and parse it correctly (e.g. use Number for number)


function baseParser(value) {
  return value === 'undefined' ? undefined : JSON.parse(value);
}

function syncWithStorage(mode, parser) {
  if (parser === void 0) {
    parser = baseParser;
  }

  var storage = getStorage(mode); // Get all key from the storage

  for (var _i = 0, _Object$entries = Object.entries(storage); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        key = _Object$entries$_i[0],
        data = _Object$entries$_i[1];
    if (!key.startsWith('swr-')) continue; // update SWR cache with the value from the storage

    cache.set(key.slice(4), parser(data), false // don't notify the cache change, no-one is listening yet anyway
    );
  } // Subscribe to SWR cache changes in the future


  return cache.subscribe(function () {
    // get all the keys in cache
    var keys = cache.keys(); // save each key in SWR with the prefix swr-

    for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i2 >= _iterator.length) break;
        _ref = _iterator[_i2++];
      } else {
        _i2 = _iterator.next();
        if (_i2.done) break;
        _ref = _i2.value;
      }

      var key = _ref;
      storage.setItem("swr-" + key, JSON.stringify(cache.get(key)));
    }
  });
}
function syncWithLocalStorage(parser) {
  return syncWithStorage('local', parser);
}
function syncWithSessionStorage(parser) {
  return syncWithStorage('session', parser);
}

export { syncWithLocalStorage, syncWithSessionStorage, syncWithStorage };
//# sourceMappingURL=swr-sync-storage.esm.js.map
